import React from 'react';
import './Loader.scss';

const AppLoader: React.FunctionComponent = () => (
  <div className="d-flex justify-content-center align-items-center p-4">
    <div className="loader">
      <span />
    </div>
  </div>
);

export default AppLoader;
